// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#000","menuText":"#fff","menuActiveText":"#fff","subMenuBg":"#000","theme":"#ff9700"};